import { IAvatarProps } from "./Avatar.types.ts";

export default function Avatar(props: IAvatarProps) {
  const { children, color, fontSize, round, size } = props;
  const sizeClass = size ? "c-avatar--" + size : "";
  return (
    <div
      className={`c-avatar${
        round ? " c-avatar--round" : ""
      } c-avatar-${color} ${sizeClass}`}
      style={
        fontSize
          ? {
              fontSize:
                fontSize === 1 ? ".75em" : fontSize === 2 ? "1.25em" : "1.5em",
            }
          : {}
      }
    >
      {children}
    </div>
  );
}
